<template>
  <div>
    <b v-if="subset">{{ subset }}</b>
    <b-table
      class="mb-0"
      :items="tableData"
      :fields="columns"
      responsive
      bordered
      striped
    />
  </div>
</template>

<script>
export default {
  name: "TimeSeriesReportTable",
  props: {
    subset: {
      type: String,
      default: null,
    },
    report: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  computed: {
    columns () {
      // get all unique elements from the data
      const elements = this.report.data.map(item => item.sample_results.map(result => result.analysis)).flat()

      return [
        { key: 'week', label: 'Week' },
        { key: 'date', label: 'Date' },
        ...[...new Set(elements)].map(element => {
          return {
            key: element,
            label: `${element}`
          }
        })
      ]
    },
    tableData () {
      return this.report.data.filter(item => item.subset == this.subset).map((item, index) => {
        const data = {
          ...item
        }

        this.columns.forEach(column => {
          if (column.key === 'week') {
            data[column.key] = index + 1
          } else if (column.key === 'date') {
            data[column.key] = item.starts_at
          } else {
            const result = item.sample_results.find(result => result.analysis === column.key)
            data[column.key] = result ? result.value : null
          }
        })

        return data
      })
    }
  }
}
</script>
